import React from 'react';
import cls from 'classnames';
import './styles.scss';

export interface CheckboxProps {
  type?: 'checkbox' | 'radio';
  className?: string;
  dimmed?: boolean;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (newValue: boolean, oldValue: boolean) => void;
  testId?: string;
}

/**
 * A smaller variant of the switch component.
 * @author Johan Svensson
 */
export const Checkbox: React.FC<CheckboxProps> = ({ checked, disabled, onChange, type = 'checkbox' }) => {
  return (
    <input
      type="checkbox"
      className={cls({
        "checkbox": true,
        "disabled": disabled,
        ["type-" + type]: true
      })}
      checked={checked}
      disabled={disabled}
      onChange={e => onChange?.(e.currentTarget.checked, checked)} />
  )
}